<template>

  <div class="paperYear">
    <el-card class="box-card" v-for="item in data">
      <template #header>
        <div class="card-header">
          <span>{{item[0].year}}</span>
        </div>
      </template>
      <div v-for="(subItem, index) in item" class="paperItem" >
        <span @dblclick="paperClick(subItem.link)" :class="{curPoint: subItem.link !== ''}">
          {{index + 1 + '. '}}{{subItem.author + '. ' + subItem.title + '. ' + subItem.journal + '.'}}
        </span>
      </div>
    </el-card>
  </div>

</template>

<script>
  import {ref, reactive, onMounted, getCurrentInstance } from 'vue';
  import { useStore } from 'vuex'
  export default {
    name: "PaperYear",
    props:{
      data: {
        type: Object,
        default: {}
      }
    },
    setup(){

      //data
      let store = useStore();


      //methods
      function paperClick(addr) {
        if (addr !== '')
          location.href = store.state.uploadFile + addr;
      }


      return{
        paperClick
      }
    }//setup
  }
</script>

<style scoped lang="less">
  .paperYear{

    .box-card {
      padding-bottom: 50px;
      .card-header{
        span{
          font-size: 30px;
        }
      }
      .paperItem{
        font-size: 16px;
        padding: 5px 0;
      }
      .paperItem:hover{
        color: #409EFF;
      }
      .curPoint{
        cursor: pointer;
      }
    }

  }
</style>